import type { CoreDataInner, ExtensionData } from '@atlassian/forge-ui-types/public/effect';

import type { ResolverContext } from '../types';

export const getResolverContext = (
	coreData: CoreDataInner,
	extensionData: ExtensionData,
): ResolverContext => ({
	...coreData,
	extension: extensionData,
});
